import React, { useContext } from 'react';
import { IStyleContext, StyleContext } from '../../styleState/styleContext';
import { TLanguageIDs, ICustomGroups } from 'types';
import LoaderWithProps from 'components/Loader/LoaderWithProps';
import { StyleSettingsCarouselUploaderNew } from 'components/StyleSettingsCarouselUploader/StyleSettingsCarouselUploaderNew';
import { NormalDisplay } from './NormalDisplay';

interface IProps {
	data: ICustomGroups;
	languageId: TLanguageIDs;
}

export const MediaGroup: React.FC<IProps> = ({ data, languageId }) => {
	const {
		deleteMediaSettingsToCarousel,
		addMediaSettingsToCarousel,
		addGroupForLoader,
		removeGroupForLoader,
		replacePdfToCarousel,
		setMediaSettingsFromNormalDisplay,
		selectedLanguage,
		groupsForLoader,
	} = useContext<IStyleContext>(StyleContext);

	const groupLoading = groupsForLoader.some((el) => el === data.id);
	const isMakeImageRequest = selectedLanguage === languageId;

	const showGroupLoader = () => {
		addGroupForLoader(data.id);
	};

	const hideGroupLoader = () => {
		removeGroupForLoader(data.id);
	};

	const displayType = () => {
		if (data.isMultipleItems) {
			return (
				<StyleSettingsCarouselUploaderNew
					group={data}
					languageId={languageId}
					selectedLanguage={selectedLanguage}
					deleteHandler={deleteMediaSettingsToCarousel}
					addItemHandler={addMediaSettingsToCarousel}
					showGroupLoader={showGroupLoader}
					hideGroupLoader={hideGroupLoader}
					replacePdfToCarousel={replacePdfToCarousel}
				/>
			);
		}
		return (
			<NormalDisplay
				group={data}
				languageId={languageId}
				showGroupLoader={showGroupLoader}
				hideGroupLoader={hideGroupLoader}
				setMediaSettingsFromNormalDisplay={setMediaSettingsFromNormalDisplay}
				groupLoading={groupLoading}
				isMakeImageRequest={isMakeImageRequest}
			/>
		);
	};

	return (
		<div className="relative">
			{displayType()}
			{groupLoading && (
				<div className="absolute inset-0 opacity-80">
					<LoaderWithProps loaderSize="big" />
				</div>
			)}
		</div>
	);
};
